import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ReactTyped } from "react-typed";
import useAuthStore from "@/stores/user/authStore";
import waytora_logo from "@/assets/logos/internal/waytora_blue_text_logo.svg";

const LogoutContent = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: "easeOut", delay: 0.3 }}
      className="text-center space-y-8"
    >
      <div className="space-y-6">
        <ReactTyped
          strings={["Logging you out..."]}
          typeSpeed={40}
          className="text-lg text-neutral-600 font-light"
        />
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="flex items-center justify-center space-x-2"
        >
          <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce [animation-delay:-0.3s]" />
          <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce [animation-delay:-0.15s]" />
          <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce" />
        </motion.div>
      </div>
    </motion.div>
  );
};

const Logout: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  useEffect(() => {
    const handleLogout = async () => {
      await logout();
      window.location.href = "/";
    };

    handleLogout();
  }, [logout, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 relative">
      <motion.img
        alt="Waytora Logo"
        src={waytora_logo}
        className="absolute top-4 left-1/2 -translate-x-1/2 w-48"
        initial={{ opacity: 0.3 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      />
      <LogoutContent />
    </div>
  );
};

export default Logout;
